/* eslint-disable prettier/prettier */
// hooks/useCreateAssessment.ts

import { useState } from 'react';
import { assessmentService } from '../services/assessment.service';
import { CreateAssessmentPayload } from '../types/assessment';
export const useCreateAssessment = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [success, setSuccess] = useState(false);

	const create = async (payload: CreateAssessmentPayload) => {
		try {
			setLoading(true);
			setError(null);
			setSuccess(false);

			const response = await assessmentService.createAssessment(payload);

			if (response.success) {
				setSuccess(true);
				return response.data; // assessment id
			} else {
				setError(response.message || 'Failed to create assessment');
				return null;
			}
		} catch (err: any) {
			setError(err?.response?.data?.message || 'Something went wrong');
			return null;
		} finally {
			setLoading(false);
		}
	};

	return {
		create,
		loading,
		error,
		success,
	};
};
